import React from 'react';
import AbsenceCategoryIcon from '../../../components/AbsenceCategoryIcon';
import { Maybe } from '../../../__generated__/graphql';

type Props = {
  categoryName: string;
  categoryIcon: string;
  categoryColor: Maybe<string>;
  requestPolicyName?: Maybe<string>;
};

export const AbsenceTypeText: React.FC<
  Pick<Props, 'categoryName' | 'requestPolicyName'>
> = ({ categoryName, requestPolicyName }) => (
  <>
    {categoryName}
    {requestPolicyName && (
      <>
        &nbsp;&#xB7;&nbsp;
        {requestPolicyName}
      </>
    )}
  </>
);

const AbsenceTypeCell: React.FC<Props> = ({
  categoryName,
  categoryIcon,
  categoryColor,
  requestPolicyName,
}) => (
  <div className="d-flex gap-2">
    <AbsenceCategoryIcon icon={categoryIcon} color={categoryColor} />
    <div>
      <div>{categoryName}</div>
      {requestPolicyName && (
        <div className="text-muted small">{requestPolicyName}</div>
      )}
    </div>
  </div>
);

export default AbsenceTypeCell;
